
export const actions = {
    GET_PROPERTIES: 'properties/getProperties',
    GET_PROPERTY: 'properties/getProperty'
}
